import dayjs from "dayjs";

export default function FiltersStatus({
    icons,
    selectedFilters,
    setSelectedFilters,
    filters,
    filterStatusBtns,
}) {

    let whenFilter = [
        {
            slug: "this-week",
            name: "This week",
        },
        {
            slug: "this-month",
            name: "This month",
        },
        {
            slug: "next-month",
            name: "Next month",
        },
    ];

    function buildStatusButtons() {
        for (const [key, value] of Object.entries(selectedFilters)) {
            switch (key) {
                case "categories":
                    filterStatusBtns.categories = getButtonsData(
                        createAssocArray(filters.categories),
                        value,
                        key,
                    );

                    break;

                case "when":
                    filterStatusBtns.when = getButtonsData(
                        createAssocArray(whenFilter),
                        value,
                        key,
                    );

                    break;

                case "composers":
                    filterStatusBtns.composers = getButtonsData(
                        createAssocArray(filters.composers),
                        value,
                        key,
                    );

                    break;

                case "locations":
                    filterStatusBtns.locations = getButtonsData(
                        createAssocArray(filters.locations),
                        value,
                        key,
                    );

                    break;

                default:
                    break;
            }
        }
    }

    function getButtonsData(AssocArray, selected, filterName) {
        let buttonsData = [];

        if (!selected) {
            return [];
        }

        for (const index of selected) {
            let labelName = AssocArray[index] ?? false;

            if (labelName) {
                let singleData = {
                    id: index,
                    name: labelName,
                    slug: index,
                    filter: filterName,
                };

                buttonsData.push(singleData);
            }
        }

        return buttonsData;
    }

    function createAssocArray(arrayOfObjects) {
        const associativeArray = arrayOfObjects.reduce((acc, current) => {
            acc[current.slug] = current.name;
            return acc;
        }, {});

        return associativeArray;
    }

    function debugFilters(selectedFilters) {
        return selectedFilters ? (
            <div>
                <pre>{JSON.stringify(selectedFilters, null, 2)}</pre>
            </div>
        ) : null;
    }

    let debugFiltersText = debugFilters(selectedFilters);

    const handleSelectedDate = (event) => {

       let  filterVals = {
            ...selectedFilters,
            cal_sel_dates: [],
        }

        setSelectedFilters(filterVals);
    }


    // Function to handle button click
    const handleClick = (event, id, filter, value) => {
        //  console.log(`Button ${id} clicked value: ${value} ${filter}`);
        event.preventDefault();

        updateFiltersState(filter, value);
    };

    function updateFiltersState(filter, value) {

        let filterArr = selectedFilters[filter];

        let filterVals;

        //console.log('filter', filterArr, filter, value );

        if (filterArr?.length) {
            if (!value) {
                return false;
            }

            if (filter == 'when') {
                filterVals = {
                    ...selectedFilters,
                    when: [],
                    when_sel_dates: [],
                }

                setSelectedFilters(filterVals);
            } else {
                // Any filter apart from when.
                let filterVals = {
                    ...selectedFilters,
                };

                searchDeleteAdd(filterArr, value);

                filterVals[filter] = filterArr;

                setSelectedFilters(filterVals);
            }
        }
    }

    /**
     *  Search an element, delete if its exist, add if it doesn't.
     * @param Array array
     * @param string element
     */
    function searchDeleteAdd(array, element) {
        const index = array.indexOf(element);

        if (index !== -1) {
            // If element exists, delete it
            array.splice(index, 1);
        } else {
            // If element doesn't exist, add it
            array.push(element);
        }
    }

    // Render JSX.
    buildStatusButtons();

    return (
        <>
            {/** debugFiltersText */}

            {selectedFilters.is_filtered ? (
                <p className="">Currently displaying results for:</p>
            ) : null}

            <ul className="filters-selected__list">
                {/** Categories selected */}
                {filterStatusBtns.categories?.length
                    ? filterStatusBtns.categories.map((button, index) => (
                          <li
                              className="filters-selected__list-item"
                              key={index}
                              onClick={(event) =>
                                  handleClick(
                                      event,
                                      button.id,
                                      button.filter,
                                      button.slug,
                                  )
                              }
                          >
                              <button
                                  key={`button-${index}`}
                                  className="btn"
                                  data-filter={button.filter}
                                  data-value={button.slug}
                              >
                                  <span className="close-icon">
                                      {icons.close_icon}
                                  </span>

                                  {button.name.replaceAll("&amp;", "&")}
                              </button>
                          </li>
                      ))
                    : null}

                {/** When selected */}
                {filterStatusBtns.when?.length
                    ? filterStatusBtns.when.map((button, index) => (
                          <li
                              className="filters-selected__list-item"
                              key={index}
                              onClick={(event) =>
                                handleClick(
                                    event,
                                    button.id,
                                    button.filter,
                                    button.slug,
                                )
                            }
                          >
                              <button
                                  key={`button-${index}`}
                                  className="btn"
                                  data-filter={button.filter}
                                  data-value={button.slug}
                              >
                                  <span className="close-icon">
                                      {icons.close_icon}
                                  </span>

                                  {button.name.replaceAll("&amp;", "&")}
                              </button>
                          </li>
                      ))
                    : null}

                {/** Composers selected */}
                {filterStatusBtns.composers?.length
                    ? filterStatusBtns.composers.map((button, index) => (
                          <li
                              className="filters-selected__list-item"
                              key={index}
                              onClick={(event) =>
                                handleClick(
                                    event,
                                    button.id,
                                    button.filter,
                                    button.slug,
                                )
                            }
                          >
                              <button
                                  key={`button-${index}`}
                                  className="btn"
                                  data-filter={button.filter}
                                  data-value={button.slug}
                              >
                                  <span className="close-icon">
                                      {icons.close_icon}
                                  </span>

                                  {button.name.replaceAll("&amp;", "&")}
                              </button>
                          </li>
                      ))
                    : null}

                {/** Locations selected */}
                {filterStatusBtns.locations?.length
                    ? filterStatusBtns.locations.map((button, index) => (
                          <li
                              className="filters-selected__list-item"
                              key={index}
                              onClick={(event) =>
                                handleClick(
                                    event,
                                    button.id,
                                    button.filter,
                                    button.slug,
                                )
                            }
                          >
                              <button
                                  key={`button-${index}`}
                                  className="btn"
                                  data-filter={button.filter}
                                  data-value={button.slug}
                              >
                                  <span className="close-icon">
                                      {icons.close_icon}
                                  </span>

                                  {button.name.replaceAll("&amp;", "&")}
                              </button>
                          </li>
                      ))
                    : null}

                {
                    selectedFilters.cal_sel_dates?.length == 1 ? (
                        <li
                        className="filters-selected__list-item"
                        key="button-sel-date-li"
                        onClick={handleSelectedDate}
                    >
                        <button
                            key="button-sel-date-btn"
                            className="btn"
                        >
                            <span className="close-icon">
                                {icons.close_icon}
                            </span>

                            {dayjs(selectedFilters.cal_sel_dates[0]).format("dddd D MMMM YYYY")}
                        </button>
                    </li>
                    ) :null
                }

            </ul>
        </>
    );
}
